import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import './style.css';
import { DesignPreview } from '../../../Components/index';
import { Link } from 'react-router-dom';

const Index = ({ design }) => {
    return (
        <div
            style={{
                overflowY: 'hidden',
                overflowX: 'auto',

                boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
                marginTop: '1.5rem',
                borderRadius: '10px',
            }}
        >
            <table className="product_library_table">
                <thead className="product_library_table_head">
                    <tr className="product_library_table_head_row">
                        <td className="product_library_table_head_data">Preview</td>
                        <td className="product_library_table_head_data">Name</td>
                        <td className="product_library_table_head_data">Category</td>
                        <td className="product_library_table_head_data">Edit</td>
                    </tr>
                </thead>
                <tbody className="product_library_table_body">
                    <Component design={design} />
                    <Component design={design} />
                    <Component design={design} />
                    <Component design={design} />
                    <Component design={design} />
                </tbody>
            </table>
        </div>
    );
};

const Component = ({ design }) => {
    return (
        <tr className="product_library_table_body_row">
            <td className="product_library_table_body_data">
                <DesignPreview sleeve={design} back={design} front={design} />{' '}
            </td>
            <td className="product_library_table_body_data">Kid's Clothing - Toddler Half Sleeve Round Neck T-Shirt</td>
            <td className="product_library_table_body_data">Orange Plain</td>
            <td className="product_library_table_body_data">
                <Link to="/main/product">
                    <EditIcon className="product_library_edit" />
                </Link>
            </td>
        </tr>
    );
};

export default Index;
